<template>
  <define-want-icon>
    <div class="want-icon-container">
      <img class="tooltip-btn-icon" src="@/assets/images/ticket.webp" />
      <span>想要</span>
    </div>
  </define-want-icon>
  <WantedSkeleton v-if="isLoading" />
  <div v-else class="wanted">
    <div class="wanted-title">
      <span class="wanted-title-text">
        <span>如何获得更多</span>
        <want-icon />
        <span>次数</span>
      </span>
      <div class="wanted-title-desc">
        {{ wantedInfo.active?.dailyRewardInfo?.content }}
        <span class="wanted-title-desc-num">+{{ wantedInfo.active?.dailyRewardInfo?.amount }}</span>
      </div>
    </div>
    <div class="wanted-section">
      <div class="wanted-section-title">
        <img class="wanted-section-title-icon" src="../../images/wanted-card1.png" alt="ticket" />
        <span class="wanted-section-title-desc">
          {{ wantedInfo.active?.currentContinuousDaysText }}
        </span>
      </div>
      <div class="wanted-section-slider">
        <div
          :style="{
            width: calculateProgress(
              wantedInfo.active?.milestones || [],
              wantedInfo.active?.currentContinuousDays || 0
            ).progressWidth
          }"
          class="wanted-section-slider-in"
        ></div>
        <div
          :style="{
            left:
              calculateProgress(
                wantedInfo.active?.milestones || [],
                wantedInfo.active?.currentContinuousDays || 0
              ).milestones[milestoneIndex].positionPercent + '%'
          }"
          v-for="(milestone, milestoneIndex) in wantedInfo.active?.milestones"
          :key="milestoneIndex"
          :class="['wanted-section-slider-icon', `icon${milestoneIndex + 1}`]"
        >
          <img src="../../images/wanted-card6.png" alt="ticket" />
          <span>+{{ milestone.tier }}</span>
        </div>
      </div>
      <div class="wanted-section-cards">
        <div
          v-for="(milestone, milestoneIndex) in wantedInfo.active?.milestones"
          :key="milestoneIndex"
          class="wanted-section-card-item"
        >
          <img
            v-if="milestone.isActive"
            class="wanted-section-card-item-icon"
            src="../../images/wanted-card2.png"
            alt="ticket"
          />
          <img
            v-else
            class="wanted-section-card-item-icon"
            src="../../images/wanted-card3.png"
            alt="ticket"
          />
          <div class="wanted-section-card-item-title">{{ milestone.requiredDaysText }}</div>
          <div
            :style="{
              color: milestone.isActive ? '#6D5DFF' : 'rgba(16, 16, 16, 0.65)'
            }"
            class="wanted-section-card-item-desc"
          >
            {{ milestone.rewardAmountText }}
          </div>
          <div
            :class="[
              'wanted-section-card-item-btn',
              getBtnClass(milestone.progressText, milestone.isActive)
            ]"
          >
            {{ milestone.progressText }}
          </div>
        </div>
      </div>
    </div>
    <div class="wanted-bottom">
      <div class="wanted-title-text">
        <span>投</span>
        <want-icon />
        <span>, 免费得整套Labubu</span>
        <span v-if="wantedInfo.wantIt?.rewardTip" class="newUser-section-title-tag">
          {{ wantedInfo.wantIt?.rewardTip }}
        </span>
      </div>
      <div
        v-if="wantedInfo.wantIt?.isClaimReward"
        @click.stop="handleToClaimHistory"
        class="wanted-bottom-btn"
      >
        历史领取
        <svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none">
          <path
            d="M0.123169 7.87668C-0.0412617 7.71225 -0.0412617 7.44565 0.123169 7.28122L3.40439 4L0.123169 0.718782C-0.0412617 0.55435 -0.0412617 0.287755 0.123169 0.123323C0.287601 -0.0411081 0.554197 -0.0411081 0.718628 0.123323L4.29757 3.70227C4.46201 3.8667 4.46201 4.1333 4.29757 4.29773L0.718628 7.87668C0.554197 8.04111 0.287601 8.04111 0.123169 7.87668Z"
            fill="#101010"
          />
        </svg>
      </div>
    </div>
    <div
      v-for="(activityItem, activityIndex) in wantedInfo.wantIt?.activity"
      :key="activityIndex"
      :class="['newUser-section', { 'subsidy-section': activityItem.name === '官方补贴' }]"
      :style="`background: ${activityItem.headerBgColorWeb};`"
    >
      <div v-show="showToast && activityIndex === 0" class="toast-container">
        该任务奖励当日已达领取上限，
        <br />
        请明日再来或联系官方客服。
      </div>
      <div class="newUser-section-title">
        <div class="newUser-section-title-left">
          <img class="newUser-section-title-icon" :src="activityItem.titleImageUrlWeb" />
        </div>
        <div v-if="activityItem.questionTipText" class="newUser-section-title-question">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M10.0013 12.9293C10.4942 12.9295 10.894 13.329 10.894 13.822C10.8937 14.3148 10.494 14.7145 10.0013 14.7148L9.99967 14.7139L9.99886 14.7148L9.90771 14.7099C9.48753 14.6674 9.15309 14.3333 9.11019 13.9132L9.10612 13.822L9.11019 13.7309C9.15573 13.2804 9.53648 12.9293 9.99886 12.9293H10.0013Z"
              fill="#101010"
              fill-opacity="0.35"
            />
            <path
              d="M8.96533 5.41382C9.46049 5.20891 10.0055 5.15556 10.5311 5.26001C11.0567 5.36447 11.5396 5.62267 11.9186 6.00138C12.2976 6.38008 12.5562 6.86274 12.6608 7.3881C12.7653 7.91346 12.7114 8.45819 12.5062 8.95304C12.301 9.44793 11.9533 9.87056 11.5076 10.168C11.2379 10.3481 10.9395 10.4766 10.6271 10.5505V11.3888C10.627 11.7338 10.3472 12.0138 10.0021 12.0138C9.65716 12.0136 9.37728 11.7337 9.37712 11.3888V10.4163C9.37712 9.81756 9.85153 9.43456 10.2926 9.3453L10.4294 9.31112C10.5649 9.26972 10.6943 9.20831 10.8135 9.12882C11.0535 8.96859 11.2409 8.74077 11.3514 8.47453C11.4618 8.20825 11.4906 7.91493 11.4344 7.63224C11.3781 7.34946 11.239 7.08916 11.0348 6.88517C10.8307 6.68135 10.5709 6.54193 10.2878 6.4856C10.0044 6.42928 9.70992 6.45816 9.44303 6.5686C9.17621 6.67907 8.94826 6.86679 8.78792 7.10653C8.62765 7.34628 8.54215 7.62806 8.54215 7.91626C8.54215 8.26143 8.26233 8.54126 7.91715 8.54126C7.57198 8.54126 7.29216 8.26143 7.29215 7.91626C7.29215 7.38059 7.45095 6.85688 7.7487 6.41154C8.04657 5.96614 8.47019 5.61874 8.96533 5.41382Z"
              fill="#101010"
              fill-opacity="0.35"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.0021 1.63696C14.6208 1.63715 18.3647 5.38172 18.3647 10.0004C18.3646 14.619 14.6207 18.3628 10.0021 18.363C5.38343 18.363 1.63886 14.6191 1.63867 10.0004C1.63867 5.3816 5.38331 1.63696 10.0021 1.63696ZM10.0021 2.88696C6.07366 2.88696 2.88867 6.07195 2.88867 10.0004C2.88886 13.9288 6.07378 17.113 10.0021 17.113C13.9304 17.1128 17.1146 13.9286 17.1147 10.0004C17.1147 6.07207 13.9305 2.88715 10.0021 2.88696Z"
              fill="#101010"
              fill-opacity="0.35"
            />
          </svg>
          <div class="tooltip-layer">
            {{ activityItem.questionTipText }}
          </div>
        </div>
      </div>
      <div class="newUser-section-content">
        <div
          v-for="(taskItem, taskIndex) in activityItem.task"
          :key="taskIndex"
          @click.stop="handleStatus(taskItem)"
          class="newUser-section-content-item"
        >
          <div class="content-item-title">
            <div class="content-item-title-left">
              <div
                :class="[
                  'content-item-title-left-wanted',
                  { active: activityItem.name === 'wantIt' }
                ]"
              >
                <span class="content-item-title-left-wanted-num" v-html="taskItem.condition"></span>
                <span v-if="taskItem.conditionTip" class="content-item-title-left-wanted-tag">
                  {{ taskItem.conditionTip }}
                </span>
              </div>
              <p class="content-item-title-left-desc">{{ taskItem.reward }}</p>
            </div>
            <div class="content-item-title-right">
              <AppTicketTime
                v-if="taskItem.expireTime"
                :time="taskItem.expireTime"
                @timeEnd="timeEndHandle"
              />
              <div
                @click.stop="handleStatus(taskItem)"
                :class="[
                  'content-item-title-right-btn',
                  getButtonClass(taskItem.status, taskItem.buttonDisable)
                ]"
              >
                {{ getButtonText(taskItem.status) }}
              </div>
            </div>
          </div>
          <div class="content-item-images">
            <div
              v-for="(productItem, productIndex) in taskItem.product"
              :key="productIndex"
              @click.stop="handleStatus(taskItem)"
              class="content-item-images-item"
            >
              <img class="content-item-image" :src="productItem.imageUrls[0]" alt="ticket" />
              <span
                @click.stop="handleStatus(taskItem)"
                v-if="productIndex === 3"
                class="content-item-image-tag"
              >
                更多可领取
                <br />
                奖励 >>
              </span>
              <span v-if="productItem.rewardStatus === 2" class="content-item-image-claim">
                <img src="../../images/wanted-card7.png" alt="ticket" />
              </span>
              <span v-if="productItem.rewardStatus === 3" class="content-item-image-claim">
                <img src="../../images/wanted-card8.png" alt="ticket" />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="activityItem.bottomDividerText" class="underline">
        <span>{{ activityItem.bottomDividerText }}</span>
      </div>
    </div>
    <div class="disclaimers">
      活动免责声明：产品图仅供参考,以实物为准,本活动与图示产品相关的泡泡玛特等品牌无关。更多活动详情请见
      <span @click.stop="goActivityRule" class="disclaimers-btn">《活动规则》</span>
    </div>
    <div @click.stop="goVoteWantIt" class="wanted-btn">去投「想要」</div>
  </div>
</template>

<script lang="ts" setup>
  import { ref, onMounted, inject } from 'vue'
  import _fetch from '@/utils/fetch'
  import { createReusableTemplate } from '@vueuse/core'
  import AppTicketTime from '../time/index.vue'
  import { goShopPages } from '../../util'
  import trackEvent from '@common/track/trackEvent'
  import WantedSkeleton from './skeleton.vue'
  const [defineWantIcon, WantIcon] = createReusableTemplate<{
    price?: string
  }>()
  const emit = defineEmits([
    'openClaimHistory',
    'openClaimRewards',
    'goVoteWantIt',
    'wantedDataLoaded'
  ])
  defineOptions({
    name: 'AppTicketWanted'
  })

  const handleToClaimHistory = () => {
    emit('openClaimHistory')
  }

  const getBtnClass = (progressText: string, isActive: boolean) => {
    if (isActive) {
      if (progressText.includes('解锁中')) {
        return 'active'
      } else if (progressText.includes('已完成')) {
        return 'active1'
      }
    } else {
      if (progressText === '已完成') {
        return 'active2'
      } else if (progressText.includes('待解锁')) {
        return 'active3'
      } else if (progressText === '已下发') {
        return 'active2'
      }
    }
  }

  const wantedInfo = ref({
    active: {} as any,
    wantIt: {} as any
  })
  const isLoading = ref(true)
  const initWanted = async () => {
    try {
      const response = await _fetch('/aigc/api/activity/progress', {
        method: 'GET'
      })
      const res = await response.json()
      if (res.code === 200) {
        wantedInfo.value = res.data
        const currentDays = wantedInfo.value.active?.currentContinuousDays || 0
        const milestones = wantedInfo.value.active?.milestones || []
        wantedInfo.value.active?.milestones.forEach((milestone: any, index: number) => {
          if (
            currentDays <= milestone.tier &&
            currentDays > (index === 0 ? 0 : milestones[index - 1]?.tier || 0)
          ) {
            milestone.isActive = true
          } else {
            milestone.isActive = false
          }
        })
        isLoading.value = false
        // 通知父组件数据加载完成
        emit('wantedDataLoaded')
      }
    } catch (error) {
      isLoading.value = false
    }
  }

  /**
   * 计算结果
   */
  interface ProgressCalculationResult {
    /** 处理后的里程碑列表（包含位置信息） */
    milestones: any[]
    /** 进度条宽度（支持calc表达式） */
    progressWidth: string
  }

  /**
   * 计算进度条宽度和节点位置（使用CSS calc表达式）
   * @param milestones 里程碑列表
   * @param currentDays 当前连续天数
   * @param iconWidth 每个icon的宽度（rpx），默认72
   * @returns 计算结果
   */
  function calculateProgress(
    milestones: any[],
    currentDays: number,
    iconWidth: number = 36 // 3d闪电icon宽度，单位rpx
    // threshold: number =  5, // 在关键节点处，icon的宽度为iconWidth + 5rpx
  ): ProgressCalculationResult {
    // console.log('milestones', milestones)
    // console.log('currentDays', currentDays)
    if (milestones.length === 0) {
      return {
        milestones: [],
        progressWidth: '0%'
      }
    }

    const totalMilestones = milestones.length
    // 每个区间的基础百分比
    const segmentPercent = 100 / totalMilestones

    // 为每个里程碑计算其位置百分比（等分布局，视觉上的位置）
    const processedMilestones = milestones.map((milestone, index) => ({
      ...milestone,
      positionPercent: ((index + 1) / totalMilestones) * 100
    }))

    let progressWidth = '0%'

    if (currentDays === 0) {
      progressWidth = '0%'
    } else {
      // 找到当前天数所在的区间
      let targetMilestoneIndex = -1
      for (let i = 0; i < processedMilestones.length; i++) {
        if (currentDays <= processedMilestones[i].tier) {
          targetMilestoneIndex = i
          break
        }
      }

      // 如果超过最后一个里程碑，则进度条为100%
      if (targetMilestoneIndex === -1) {
        progressWidth = '100%'
      } else {
        // 计算区间的起始天数和结束天数
        // debugger
        const startMilestone =
          targetMilestoneIndex === 0 ? null : processedMilestones[targetMilestoneIndex - 1]
        const startDay = startMilestone?.tier || 0
        const endMilestone = processedMilestones[targetMilestoneIndex]
        const endDay = endMilestone.tier

        const daysInSegment = endDay - startDay

        // 基础里程碑位置, 第一个区间基础位置为0
        const basePositon = targetMilestoneIndex * segmentPercent

        // 计算区间中占据的位置
        let segmentPosition = ''
        // 如果当前天数正好是区间的结束天数，则直接使用区间的百分比
        if (daysInSegment === currentDays - startDay) {
          segmentPosition = `${segmentPercent}%`
        } else {
          segmentPosition = `((${segmentPercent}% - ${iconWidth}px)/${daysInSegment}) * (${currentDays - startDay})`
        }

        // 分成两部分，基础里程碑位置 + 区间均分位置
        progressWidth = `calc(${basePositon}%  + ${segmentPosition} )`
      }
    }
    // console.log('progressWidth', progressWidth)
    return {
      milestones: processedMilestones,
      progressWidth
    }
  }

  const getButtonText = (status: string) => {
    switch (status) {
      case 'WAITING':
        return '待解锁'
      case 'UNCLAIM':
        return '领取'
      case 'ISSUED':
        return '已领取'
      case 'UNLOCKING':
        return '领取'
      case 'EXPIRED':
        return '已失效'
    }
  }

  const getButtonClass = (status: string, buttonDisable: boolean) => {
    if (status === 'WAITING') {
      return 'waiting'
    } else if (status === 'UNCLAIM') {
      if (buttonDisable) {
        return 'waiting'
      } else {
        return 'unclaim'
      }
    } else if (status === 'ISSUED') {
      return 'issued'
    } else if (status === 'UNLOCKING') {
      return 'unclaim'
    } else if (status === 'EXPIRED') {
      return 'expired'
    }
  }
  const showToast = ref(false)
  const handleStatus = (taskItem: any) => {
    if (
      taskItem.buttonDisable &&
      (taskItem.status === 'UNCLAIM' || taskItem.status === 'UNLOCKING')
    ) {
      showToast.value = true
      setTimeout(() => {
        showToast.value = false
      }, 3000)
      return false
    }
    emit('openClaimRewards', taskItem.taskId)
  }

  const goVoteWantItProduct = (productItem: any) => {
    if (productItem.webUrl) {
      window.open(`${productItem.webUrl}?from=want_task_page`, '_blank')
    } else {
      goShopPages(`/detail/${productItem.productId}?from=want_task_page`, 'new')
    }
  }

  const goVoteWantIt = () => {
    emit('goVoteWantIt')
  }

  const goActivityRule = () => {
    window.open(
      'https://zaohaowu.com/docs/%E6%B4%BB%E5%8A%A8%E8%A7%84%E5%88%99%E3%80%8C%E6%83%B3%E8%A6%81%E6%BF%80%E5%8A%B1%E7%8E%A9%E6%B3%95%E3%80%8D',
      '_blank'
    )
  }

  const resetWanted = () => {
    isLoading.value = true
    wantedInfo.value = {
      active: {} as any,
      wantIt: {} as any
    }
  }

  const timeEndHandle = () => {
    setTimeout(() => {
      // resetWanted()
      initWanted()
    }, 2000)
  }

  onMounted(() => {
    initWanted()
  })
</script>

<style lang="stylus" scoped>
  @import './index.styl'
</style>
